// extracted by mini-css-extract-plugin
export default {"imageWrap":"styles_imageWrap__eW6Sb","textWrap":"styles_textWrap__crC8C"};